import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { gsap ,Sine, Quint, Expo, Quad, Back, Elastic, Cubic, Power1, Power2 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// @mui
import { styled } from '@mui/material/styles';
import {
  Box,
  AppBar,
  Toolbar,
} from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';

// hooks
import useResponsive from '../../../hooks/useResponsive';

// components
import { LogoAnimation } from '../../../components/logo';

// store
import { HEADER } from '../../../store/constant';

// _mock
import HeaderHorizontal from './HeaderHorizontal';
import HeaderVertical from './HeaderVertical';
import { getStorage } from '../../../utils/storage';
import { ACCESS_TOKEN } from '../../../store/types';


// registerPlugin
gsap.registerPlugin(ScrollTrigger);


// =================================|| STYLED ||================================= //

const HeaderRoot = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isBlur',
})(({ isBlur, theme }) => ({
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    backgroundColor: 'transparent',
  },
  [theme.breakpoints.down('lg')]: {
    backgroundImage: theme.palette.gradients.header,
  },
  // [theme.breakpoints.down('sm')]: {
  //   backgroundImage: theme.palette.gradients.header,
  // },
  ...(isBlur ? {
    backdropFilter: 'blur(10px)',
    backgroundImage: theme.palette.gradients.header,
  } : {
    // backgroundImage: theme.palette.gradients.header1,
  }),
}));



const ToolbarRoot = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== 'isBlur',
})(({ isBlur, theme }) => ({
  // ...bgBlur({ 
  //   blur: isBlur ? '22' : '0', 
  //   color: theme.palette.background.paper, 
  //   opacity: '0' 
  // }),
  alignItems: 'stretch',
  padding: `${theme.spacing(0, 6)} !important`,
  minHeight: `${HEADER.DESKTOP_HEIGHT}px !important`,
  transition: theme.transitions.create(['all'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.down('lg')]: {
    padding: `${theme.spacing(0, 3)} !important`,
    minHeight: `${HEADER.MOBILE_HEIGHT}px !important`,
  },
}));

// =================================|| HEADER ||================================= //


Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header() {
  const { account: { profile, navigations, serviceApplications } } = useSelector((state) => state);

  const isDesktop = useResponsive('up', 'lg');

  const [opened, setOpened] = useState(false);

  const [active, setActive] = useState(false);

  const existToken = getStorage(ACCESS_TOKEN);

  useEffect(() => {
    ScrollTrigger.create({
      start: "1px top",
      end: "1px bottom",
      markers: false,
      scrub: true,
      id: "fixedHeader",
      toggleActions: "play none reverse none",
      onUpdate: () => {
      }, // 监听滚动事件  // 在start和end区域内滚动位置改变时触发
      onEnterBack: () => {
        // console.log('onEnterBack:::', '再滚回来')
      },  // 滚动超过end位置，再进入滚动区域触发
      onEnter: () => {
        // console.log('滚动到start位置触发')
        // swiperContainer.style.setProperty("position", "fixed");
      },
      onLeave: () => {
        setActive(true)
        // console.log('滚出end位置时触发')
      },
      onLeaveBack: () => {
        setActive(false)
        // console.log('滚出end位置，再滚回来超过start位置触发')
      },
      onToggle: self => console.log("toggled, isActive:", self.isActive),
    });

    ScrollTrigger.addEventListener("refreshInit", () => {
      // onAccountCardAnimation();
    });
    ScrollTrigger.addEventListener("scrollStart", () => {
      // onAccountCardAnimation(0, 0.5, "none");
    });
    ScrollTrigger.addEventListener("scrollEnd", () => {
      // onAccountCardAnimation();
    });
  }, []);


  return (
    <HeaderRoot isBlur={active}>
      <ToolbarRoot isBlur={active}>

        <LogoAnimation />

        <Box sx={{ flexGrow: 1 }} />

        { isDesktop ? (
          <HeaderHorizontal existToken={existToken} profile={profile} navigations={navigations} applications={serviceApplications} />
        ) : (
          <HeaderVertical existToken={existToken} profile={profile} navigations={navigations} openNav={opened} onOpenNav={() => setOpened(!opened)} onCloseNav={() => setOpened(false)} />
        )}

      </ToolbarRoot>
    </HeaderRoot>
  );
}
